import type { FaireProductEntity } from "../../entity_types/product";

export const p_svdhgb9adh: FaireProductEntity = {
  token: "p_svdhgb9adh",
  type: "product",
  name: "Bee Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/5584aafbe61968c24c34795c2159d19ccd6e06bea06a3de4598fb12b63497efd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9228a2cab8feca128c76e2e178a0f1fa3cb82600ac2c26009f4396088142b6be.jpeg",
    "https://cdn.faire.com/fastly/73d7b367bb6e56b90dbba674a2226f7e3c061b8e17c4ab0cd83ad45fd79e8862.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:07.810Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
